<template>
    <div class="subservice-header-title-container">
        <q-breadcrumbs>
            <q-breadcrumbs-el :label="menu" />
            <q-breadcrumbs-el :label="service" :to="service_path" />
            <q-breadcrumbs-el :label="subservice" />   
          </q-breadcrumbs>
          <div class="subservice-header-btn-container">
            <q-btn v-if="isBtnBackEnable" color="primary" label="Regresar" @click="onBackBtn"/>
            <q-btn v-if="isBtnExportEnable" color="primary" label="Exportar" @click="onExportBtn"/>
          </div>
    </div>
    
    <div class="subservice-header-menu">
        <div v-for="(opt, index) in options" :key="index"
            :class="(opt.active) ? 'subservice-header-menu-opt-active' : 'subservice-header-menu-opt'"
            @click="selectOption(opt)">
            {{ opt.name }}
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { SubserviceHeaderOption } from './intefaces/subservice-header-option';
import { SubserviceHeaderProps } from './intefaces/subservice-header-props';
import { useRoute } from 'vue-router';

export default defineComponent({
    name: 'subservices-header',
    props: {
        options: {
            type: Object as () => Array<SubserviceHeaderOption>,
            required: true
        },
        menu: {
            type: String,
            required: true
        },
        service: {
            type: String,
            required: true
        },
        service_path: {
            type: String,
            required: true
        },
        subservice: {
            type: String,
            required: true
        },
        isBtnBackEnable: {
            type: Boolean,
            default: true
        },
        isBtnExportEnable: {
            type: Boolean,
            default: false
        }
    },
    emits: ['option_select', 'click_back', 'click_export'],
    setup(props: SubserviceHeaderProps, { emit }) {
        const route = useRoute();

        const selectOption = (opt: SubserviceHeaderOption) => {
            emit('option_select', opt);
        }

        const onBackBtn = () => {
            emit('click_back', null);
        }

        const onExportBtn = () => {
            emit('click_export', route.name);
        }

        return {
            selectOption,
            onBackBtn,
            onExportBtn
        }
    }
});
</script>

<style lang="scss">
.subservice-header {
    &-title-container {
        font-size: 1.2em;
        margin-top: 15px;
        margin-bottom: 5px;
        display: flex;
        justify-content: space-between;

        >.title {
            margin: 0;
            font-size: 1.7rem;
            color: var(--q-primary);
            font-weight: 500;
        }
    }

    &-menu {
        display: flex;
        border-top: 1px solid var(--q-primary);
        border-bottom: 1px solid var(--q-primary);

        &-opt {
            margin: 5px;
            padding: 5px;
            color: var(--q-primary);
            cursor: pointer;

            &-active {
                padding: 10px;
                background-color: var(--q-primary);
                color: #FFF;
                cursor: pointer;
            }
        }
    }
}

@media (max-width: 575.98px) {
    .subservice-header {
        &-btn-container {
            visibility: hidden;
        }
    }
}
</style>
